import { useState } from 'react'

import { EMPTY_OBJECT } from '../../constants/common'
import { useIntersectionObserver } from '../useIntersectionObserver'

import {
  INFINITE_ITEMS_LOAD_ON_SCROLL_THRESHOLD_INDEX_FROM_LIST_END,
  OBSERVER_OPTIONS,
} from './useInfiniteItemsLoadOnScroll.constants'
import { isThresholdIndex } from './useInfiniteItemsLoadOnScroll.utils'

export function useInfiniteItemsLoadOnScroll({
  fetchData,
  getApiParamsLoadNext,
  hasMoreRef,
  isLoadingMore = false,
  items,
  observerOptions = OBSERVER_OPTIONS,
  thresholdEndIndex = INFINITE_ITEMS_LOAD_ON_SCROLL_THRESHOLD_INDEX_FROM_LIST_END,
}) {
  const [thresholdElement, setThresholdElement] = useState(null)

  // `getApiParamsLoadNext` may snapshot the list it pages from, so it runs only
  // for a page that starts.
  function observerCallback(entries) {
    const target = entries[0]

    if (target.isIntersecting && hasMoreRef.current && !isLoadingMore) {
      fetchData(getApiParamsLoadNext(items))
    }
  }

  useIntersectionObserver({
    observerCallback,
    observerOptions,
    thresholdElement,
  })

  function getThresholdItemProps(index) {
    return {
      ...(isThresholdIndex(items, index, thresholdEndIndex)
        ? { ref: setThresholdElement }
        : EMPTY_OBJECT),
    }
  }

  return { getThresholdItemProps }
}
